import * as PickstarUserAnalytics from '@pickstar/user-analytics'

export default {
  computed: {
    analytics () {
      return PickstarUserAnalytics
    }
  },
  methods: {
    trackEvent (Event, additionalParams = {}) {
      const trackingEvent = new Event()
      const params = Object.keys(trackingEvent)
      params.forEach(param => {
        if (param in additionalParams) {
          trackingEvent[param] = additionalParams[param]
        } else if (this.resolveParam(param)) {
          trackingEvent[param] = this.resolveParam(param)
        }
      })
      if (this.$analytics) {
        this.$analytics.track(trackingEvent)
      }
    },

    resolveParam (param) {
      switch (param) {
        case 'jobId':
          if (this.booking && this.booking.id) {
            return this.booking.id
          }
          return null
        case 'jobStatus':
          if (this.booking && this.booking.status) {
            return this.getBookingStatus()
          }
          return null
        case 'jobNumberOfStarsApplied':
          if (this.bookingAppliedTalent) {
            return this.bookingAppliedTalent.count
          }
          return null
        case 'jobNumberOfStarsRequired':
          if (this.booking && this.booking.required_stars) {
            return this.booking.required_stars
          }
          return null
        case 'jobNumberOfStarsSelected':
          if (this.bookingAttendingTalentCount) {
            return this.bookingAttendingTalentCount
          }
          return null
        case 'talentName':
          if (this.bookingAttendingTalent) {
            return this.bookingAttendingTalent.map(element => element.name)
          }
          return null
        case 'talentId':
          if (this.bookingAttendingTalent) {
            return this.bookingAttendingTalent.map(element => element.id)
          }
          return null
        case 'jobStarAddedType':
          return PickstarUserAnalytics.V2.JobStarAddedType.TALENT_NOTIFIED
        case 'jobDeclineReason':
          if (this.declineRequestReason) {
            return this.declineRequestReason
          }
          return null
        case 'jobWithdrawReason':
          if (this.withdrawRequestReason) {
            return this.withdrawRequestReason
          }
          return null
        case 'jobTotalNotesAdded':
          if (this.notes) {
            return this.notes.length
          }
          return null
        case 'jobCreatedAt':
          if (this.booking) {
            return this.booking.created_at
          }
          return null
        case 'jobType':
          if (this.booking && this.booking.opportunities) {
            return this.booking.opportunities.flatMap((job, index) => [job ? job.name : ''])
          }
          return null
        case 'jobValue':
          return this.booking ? this.booking.budget_per_star : null
        case 'jobRegion':
          if (this.booking && this.booking.region) {
            return this.booking.region.shortname
          }
          return null
        case 'jobSubRegion':
          if (this.booking && this.booking.region) {
            return this.booking.region.timezone
          }
          return null
        case 'fileType':
          return this.file ? this.file.file_type : null
        case 'fileName':
          return this.file ? this.file.file_name : null
        case 'jobPdfViewType':
          return this.getPdfViewType()
      }
      return null
    },
    getPdfViewType () {
      if (!this.target) {
        return null
      }

      switch (this.target) {
        case 'admin':
          return PickstarUserAnalytics.V2.PdfViewType.ADMIN_VIEW
        case 'client':
          return PickstarUserAnalytics.V2.PdfViewType.CLIENT_VIEW
        case 'talent':
          return PickstarUserAnalytics.V2.PdfViewType.TALENT_VIEW
        default:
          return PickstarUserAnalytics.V2.PdfViewType.ADMIN_VIEW
      }
    },
    getBookingStatus () {
      switch (this.booking.status.toLowerCase()) {
        case 'draft':
          return PickstarUserAnalytics.V2.JobStatusType.DRAFT
        case 'request':
          return PickstarUserAnalytics.V2.JobStatusType.REQUEST
        case 'scheduled':
          return PickstarUserAnalytics.V2.JobStatusType.SCHEDULED
        case 'booked':
          return PickstarUserAnalytics.V2.JobStatusType.BOOKED
        case 'withdrawn':
          return PickstarUserAnalytics.V2.JobStatusType.WITHDRAWN
        case 'declined':
          return PickstarUserAnalytics.V2.JobStatusType.DECLINED
        case 'complete':
          return PickstarUserAnalytics.V2.JobStatusType.COMPLETE
        case 'pending':
          return PickstarUserAnalytics.V2.JobStatusType.VETTING // return 'Pending'
        default:
          return PickstarUserAnalytics.V2.JobStatusType.VETTING
      }
    }
  }
}
